import React from "react";

const Hiring = () => {
  return (
    <div id="hiring-steps">
      <p>
        We have a clear consistent hiring process that we use in all our
        business units. All candidates who wish to work with us have to go
        through this process.<b>There are no exemptions.</b>
      </p>
      <ol>
        <li>
          Pre-vetting phase: from the list of all applicants we select a pool of
          candidates with the most appropriate skills that matches the job
          description. Sometimes we can select a candidate whose skills doesn
          not entirely matches the job description but has attributes that
          resembles quick learning and adjusting.
          <b>We value the skillholder more than the skill itself.</b>{" "}
        </li>
        <li>
          If you make it through the pre-vetting stage, a <b>Soft Skills</b>{" "}
          interview is the next step. At this stage we assess the interaction
          skills of a candidate. In our organization, we value working as a team
          so we hire candidates who prove that they are good team players.
        </li>
        <li>
          Candidates who make it through the Soft Skills Interview are then
          invited to Technical Interviews conducted by Department specialists
          from the departments they are applying to. At this stage a candidate
          has to prove his/her job capability (<b>potential also considered</b>)
        </li>
        <li>
          Candidates who pass the Technical Interview, are given job offers in
          which they have to either accept or decline within 7 working days
        </li>
      </ol>
    </div>
  );
};
export default Hiring;
